import {
  AutocompleteRenderInputParams,
  CircularProgress,
  TextField as MuiTextField,
  TextFieldProps,
} from '@mui/material';
import { Ref } from 'react';
import { useTranslation } from '../../../../../modules/translation/TranslationContext';
import { AutocompleteTextFieldProps } from '../autocomplete.types';

interface Props extends AutocompleteTextFieldProps {
  params: AutocompleteRenderInputParams;
  loading?: boolean;
  size: TextFieldProps['size'];
  fullWidth: boolean;
  inputRef: Ref<HTMLInputElement>;
  testId?: string;
}

function AutocompleteTextField({
  params,
  loading,
  size,
  fullWidth,
  inputRef,
  label,
  helperText,
  error,
  placeholder,
  required,
  name,
  autoFocus,
  testId,
}: Props) {
  const { translate } = useTranslation();

  return (
    <MuiTextField
      {...params}
      variant="outlined"
      size={size}
      fullWidth={fullWidth}
      label={label}
      helperText={helperText}
      error={error}
      placeholder={placeholder ? translate(placeholder) : undefined}
      required={required}
      name={name}
      autoFocus={autoFocus}
      inputRef={inputRef}
      slotProps={{
        htmlInput: { ...params.inputProps, 'test-id': testId },
        input: {
          ...params.InputProps,
          endAdornment: (
            <>
              {loading ? <CircularProgress color="inherit" size={14} /> : null}
              {params.InputProps.endAdornment}
            </>
          ),
        },
      }}
    />
  );
}

export default AutocompleteTextField;
